import { Tooltip } from "@mui/material";
import { withStyles } from "@mui/styles";

const WhiteBackgroundStyles = withStyles({
    tooltip: {
        padding: '1rem',
        color: "#000 !important",
        backgroundColor: "#fff !important",
        display: 'flex',
        gap: '0.25rem',
        border: 'solid 1px #d8d8d8',
        flexWrap: "wrap",
        whiteSpace: 'nowrap'
    }
})(Tooltip);

const WhiteBackgroundTooltip = (props) => {
    return (
        <WhiteBackgroundStyles  {...props} />
    )
}


export default WhiteBackgroundTooltip;